import { render, staticRenderFns } from "./TranslateText.vue?vue&type=template&id=415ef1f3"
import script from "./TranslateText.vue?vue&type=script&lang=js"
export * from "./TranslateText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports